import { Modal } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { ReactElement } from 'react';

interface MessageInputPDFPreviewProps {
  opened: boolean;
  onClose: () => void;
  file: File | null;
  pdfUrl: string | null;
}

export function MessageBoxPDFPreview({ opened, onClose, file, pdfUrl }: MessageInputPDFPreviewProps): ReactElement {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={file?.name || 'PDF Preview'}
      size="95vw"
      p="0"
      closeButtonProps={{
        icon: <IconX size={20} />,
      }}
    >
      {pdfUrl && <iframe src={pdfUrl} style={{ width: '100%', height: '70vh', border: 'none' }} title="PDF Preview" />}
    </Modal>
  );
}
